import dragula from 'dragula'

$.onmount('[data-component=shipping_method_preferences]', function () {
  var $el = $(this)
  var $saveStatus = $el.find('#save-status')
  var savingText = $el.data('savingText') || 'Saving...'
  var savedText = $el.data('savedText') || 'Saved!'
  var failedText = $el.data('failedText') || 'Failed to save'

  var showStatus = function (message, type) {
    var badgeClass = type === 'success' ? 'badge-success' : (type === 'error' ? 'badge-danger' : 'badge-secondary')
    $saveStatus.html('<span class="badge ' + badgeClass + '">' + message + '</span>')

    if (type === 'success') {
      setTimeout(function () {
        $saveStatus.find('.badge').fadeOut(300, function () {
          $(this).remove()
        })
      }, 2000)
    }
  }

  var recalculatePreferences = function ($list) {
    $list.find('.sortable-item').each(function (index) {
      $(this).find('.preference-number').text(index + 1)
    })
  }

  var savePreferences = function ($list) {
    var preferenceType = $list.data('preferenceType')
    var orderedIds = $list.find('.sortable-item').map(function () {
      return $(this).data('id')
    }).get()

    showStatus(savingText, 'saving')

    $.ajax({
      url: '/shipping_methods/update_preferences',
      method: 'PATCH',
      headers: {
        'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
      },
      contentType: 'application/json',
      data: JSON.stringify({
        preference_type: preferenceType,
        ordered_ids: orderedIds
      }),
      success: function () {
        showStatus(savedText, 'success')
      },
      error: function (xhr) {
        var errorMsg = failedText
        if (xhr.responseJSON && xhr.responseJSON.error) {
          errorMsg = xhr.responseJSON.error
        }
        showStatus(errorMsg, 'error')
      }
    })
  }

  // Initialize dragula for each sortable list
  $el.find('.sortable-list').each(function () {
    var $list = $(this)

    dragula([this]).on('drop', function () {
      recalculatePreferences($list)
      savePreferences($list)
    })
  })
})
